import { render, staticRenderFns } from "./handleDetail.vue?vue&type=template&id=3d325525&scoped=true&"
import script from "./handleDetail.vue?vue&type=script&lang=js&"
export * from "./handleDetail.vue?vue&type=script&lang=js&"
import style0 from "./handleDetail.vue?vue&type=style&index=0&id=3d325525&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d325525",
  null
  
)

export default component.exports